import { useTopStore } from '@/store/top'
import { storeToRefs } from 'pinia'
import * as Sentry from '@sentry/vue'

const checkIsInternalClientId = (clientId: string | null): boolean => {
  const stgTesterHashedUAIDs = [
    '0c53837163ea2f678da81196aa87e266ef5153e542dda2b3173273a42a6e0cc8',
    '0bceebcc3977d229d7b7faaf8d43841ae8fa43581d2502c0dd3e2e1283c82a55',
    '25ee1fab8a2330e6be1fb06dc065d6ca8404ae670afde7b670c16eb89c7e1014',
    // Account: 080-1111-0450/Pay2test
    '32a7605db04e2c9f867ccf8797f99acba08711d37027b04fa2918f4a06ed664e',
    // Account: 080-1111-0289/Pay2test
    'fa12cd4fbb01434caf888db601759a24e420ddeb2a0e61001e640de1de6fc3ab',
  ]

  const prodTesterHashedUAIDs = [
    // Li 
    '2e16be5c1545e3746afe95e817b900f0c94a95cc9e7ef2db04bb66ec802ff530',
    // Harry
    '16921f073c5473082d54c3ac2063832bfcd410b0aa538bce64f1d1864085ab56',
  ]

  const isProd = g.envProd()
  return isProd
    ? prodTesterHashedUAIDs.includes(clientId || '')
    : stgTesterHashedUAIDs.includes(clientId || '')
}

export const loggerFatal = (message: string, info?: string, _clientId?: string) => {
  const topStore = useTopStore()
  const { clientId } = storeToRefs(topStore)
  const clientIdToUse = _clientId || clientId.value

  const isInternalTesterByHashedUAID = checkIsInternalClientId(clientIdToUse)

  if (isInternalTesterByHashedUAID)
    Sentry.logger.fatal(clientIdToUse?.slice(0, 5) + ' ' + message, { info: info })
}
